'use strict';
'no babel-plugin-flow-react-proptypes';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNav = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/core/styles');

var _BodyClass = require('../BodyClass');

var _BodyClass2 = _interopRequireDefault(_BodyClass);

var _ScrollContainer = require('./ScrollContainer');

var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);

var _TabManager = require('./TabManager');

var _TabManager2 = _interopRequireDefault(_TabManager);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = React.createElement(_BodyClass2.default, { classNames: _constants.hasSecondaryNavClass });

var _ref3 = React.createElement(_BodyClass2.default, { classNames: _constants.hasSecondaryNavTallClass });

var _ref4 = React.createElement(_ScrollContainer2.default, null);

var SecondaryNav = exports.SecondaryNav = function (_React$Component) {
  (0, _inherits3.default)(SecondaryNav, _React$Component);

  function SecondaryNav() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SecondaryNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SecondaryNav.__proto__ || (0, _getPrototypeOf2.default)(SecondaryNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasIconTabs: false,
      hasLabelTabs: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SecondaryNav, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        praxis: {
          accentClass: this.props.accentClass
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var firstChild = React.Children.toArray(this.props.children)[0];

      if (firstChild) {
        this.setState({
          hasIconTabs: !!firstChild.props.icon,
          hasLabelTabs: !!firstChild.props.label
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          classes = _props.classes;
      var _state = this.state,
          hasIconTabs = _state.hasIconTabs,
          hasLabelTabs = _state.hasLabelTabs;

      var isTall = hasIconTabs && hasLabelTabs;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: classes.secondaryNav },
          _ref2,
          isTall && _ref3,
          React.createElement(
            _TabManager2.default,
            { rawInput: children },
            _ref4
          )
        ),
        React.createElement('div', { className: classes.spacer })
      );
    }
  }]);
  return SecondaryNav;
}(React.Component);

SecondaryNav.defaultProps = {
  classes: {}
};


SecondaryNav.childContextTypes = {
  praxis: _propTypes2.default.shape({
    accentClass: _propTypes2.default.string
  })
};

SecondaryNav.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node
} : {};

var stylesheet = function stylesheet(theme) {
  var _secondaryNav, _spacer;

  return {
    secondaryNav: (_secondaryNav = {
      height: 48,
      zIndex: theme.zIndex.appBar + 1,
      position: 'fixed',
      top: 56
    }, (0, _defineProperty3.default)(_secondaryNav, theme.breakpoints.up('xs') + ' and (orientation: landscape)', {
      top: 48
    }), (0, _defineProperty3.default)(_secondaryNav, theme.breakpoints.up('sm'), {
      top: 64
    }), (0, _defineProperty3.default)(_secondaryNav, theme.breakpoints.down('md'), {
      overflowY: 'hidden',
      width: '100%'
    }), _secondaryNav),
    spacer: (_spacer = {
      height: 56
    }, (0, _defineProperty3.default)(_spacer, theme.breakpoints.up('xs') + ' and (orientation: landscape)', {
      height: 48
    }), (0, _defineProperty3.default)(_spacer, theme.breakpoints.up('sm'), {
      height: 64
    }), _spacer),
    contentOffset__tall: {
      height: 72
    },
    toolbarRoot__tall: {
      height: '72px !important'
    }
  };
};

exports.default = (0, _styles.withStyles)(stylesheet)(SecondaryNav);